import React, { Component } from "react";
import { Mutation, Query } from "react-apollo";
import Filter from "components/Filter";
import t from "@zendesk/client-i18n-tools";
import gql from "graphql-tag";
import { removeFilterMutation } from "mutations/removeFilterMutation";
import PropTypes from "prop-types";

import styles from "./styles.css";

const dirtyStateQuery = gql`
  query {
    dirtyState @client {
      filters {
        id
        type
        value
      }
    }
  }
`;

export default class FilterList extends Component {
  static propTypes = {
    removable: PropTypes.bool,
  };

  state = {};
  render() {
    const { removable } = this.props;
    return (
      <Query query={dirtyStateQuery}>
        {({ data: { dirtyState } }) => (
          <div dir={t.dir} className={styles.filters} data-test-id="filters">
            {dirtyState.filters.map(
              ({ id, type, value }) =>
                removable ? (
                  <Mutation
                    key={id}
                    mutation={removeFilterMutation}
                    variables={{ id }}
                  >
                    {mutate => (
                      <Filter onClick={mutate} type={type} value={value} />
                    )}
                  </Mutation>
                ) : (
                  <Filter key={id} type={type} value={value} />
                )
            )}
          </div>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterList/index.js